import {inject, Type} from '@angular/core';
import {ApBaseClass, GenericControlValueAccessor, stringifyClass} from 'webcommon/shared';
import {ControlValueAccessor, NgControl} from '@angular/forms';

// chain this CVA off another one attached to the same element
export function ApChainCVA<TBaseCVA extends ControlValueAccessor>(BaseCVA: Type<TBaseCVA>) {
  return <TValueInput, TValueOutput = TValueInput>() => {
    return class extends ApBaseClass implements GenericControlValueAccessor<TValueInput, TValueOutput> {
      readonly ngControlDirective: NgControl = inject(NgControl, {
        self: true,
      });

      readonly baseCVA: TBaseCVA;

      constructor(
      ) {
        super();
        const baseCVA = this.ngControlDirective.valueAccessor;
        if (!baseCVA) {
          throw new Error('No baseCVA.');
        }
        if (!(baseCVA instanceof BaseCVA)) {
          throw new Error(`Invalid baseCVA. expected type ${stringifyClass(BaseCVA)}, but was ${stringifyClass(baseCVA)}`);
        }
        this.baseCVA = baseCVA;
        this.ngControlDirective.valueAccessor = this;
      }

      registerOnChange(fn: (value: TValueOutput) => void): void {
        this.baseCVA.registerOnChange(fn);
      }

      registerOnTouched(fn: () => void): void {
        this.baseCVA.registerOnTouched(fn);
      }

      writeValue(obj: TValueInput): void {
        this.baseCVA.writeValue(obj);
      }

      setDisabledState(isDisabled: boolean): void {
        this.baseCVA.setDisabledState?.(isDisabled);
      }
    };
  };
}
